module.exports = __webpack_public_path__ + "img/showroom-fashionweek-bg.89c485a.webp";